const NominalProfitLoss = {
  type: 'NominalProfitLoss',
  title: 'Profit And Loss',
  formTitle: 'Profit And Loss',
  formUrl: '/Nominal/ProfitLoss/Details',
  workspaceUrl: '/menu/Nominal',
  screenReference: 'NOMINAL_PROFITLOSS',
  operations: 0,
};

export default NominalProfitLoss;
